import { render, staticRenderFns } from "./BelongCreate.vue?vue&type=template&id=3210bd9c&scoped=true"
import script from "./BelongCreate.vue?vue&type=script&lang=js"
export * from "./BelongCreate.vue?vue&type=script&lang=js"
import style0 from "./BelongCreate.vue?vue&type=style&index=0&id=3210bd9c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3210bd9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3210bd9c')) {
      api.createRecord('3210bd9c', component.options)
    } else {
      api.reload('3210bd9c', component.options)
    }
    module.hot.accept("./BelongCreate.vue?vue&type=template&id=3210bd9c&scoped=true", function () {
      api.rerender('3210bd9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/reserve/BelongCreate.vue"
export default component.exports